import { useTranslation } from "react-i18next";

export const NoResults = ({ query }) => {
  const { t } = useTranslation();
  
  return (
    <div className="text-center py-5 d-flex flex-column align-items-center">
      <div className="mb-3">
        <i className="icon icon-lg bi bi-search-heart bg-danger fs-3 bg-opacity-25 text-danger mb-3 mx-auto"></i>
        <h4>{t("search.modal.noResults.title")}</h4>
        {query && query.length > 0 ? (
          <p className="text-secondary mb-0">
            {t("search.modal.noResults.description", { query })}
          </p>
        ) : (
          <p className="text-muted mb-0">{t("search.modal.noResults.fallback")}</p>
        )}
      </div>
    </div>
  );
};
